<template id="dc-vizlet">
    <section>

<!-- card start-->
                <div class="card m-3" v-if="dcViz.visibleFlag === true">
<!-- card header for the DC vizlet-->
                    <div class="card-header d-flex justify-content-between">

<!--                        <div class="">{{dcViz.y1_axisDisplayName}} vs {{dcViz.x1_axisDisplayName}}</div>-->
                      <div class="">{{dcViz.vizletTitleDpName}}</div>

                      <a class="txt-color-white right-padding-50"
                           @click="commentBox()">
                            <i class="fa fa-lg fa-comments"></i>
                        </a>
                    </div>
<!-- card body for the DC vizlet -->
                    <div :class="[dcViz.viztypeName=='DC dataTable' ? 'card-body scrollbar':'card-body']">
                        <div :id="id" ref="r1c1">
                            <a class='reset'
                               v-on:click="resetChartFunc()"
                               style='visibility: hidden;'>reset</a>
                        </div>
                    </div>
                </div>




        <b-modal ref="comment-box" @ok="postAnnotation()" :title="annotationTitle">
            <b-form-group label="Comment">
                <textarea rows="3" cols="50" v-model="cmnt"
                          placeholder="Write a comment..."></textarea>
            </b-form-group>
        </b-modal>

        <b-modal id="report-box" :title="reportTitle">
            <b-form-group label="Report">
                <table class="table  table-borderless">
                    <thead class="thead-light">
                    <tr>
                        <th>Time</th>
                        <th>Person</th>
                        <th>Page</th>
                        <th>Section</th>
                        <th>Comment</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(item, idx) in annotations" v-bind:key="idx">
                        <td>{{item.createTimestamp}}</td>
                        <td class="username">{{item.userName}}</td>
                        <td> {{item.page}}</td>
                        <td> {{item.section}}</td>
                        <td> {{item.annotation}}</td>
                    </tr>
                    </tbody>
                </table>
            </b-form-group>
        </b-modal>
    </section>
</template>
<script>

import * as dc from 'dc'
import axios from 'axios'
import {DcChartInfo} from '@/models'
import {bus} from "@/bus"

export default {
        name: "dc-vizlet",
        props: {
            dcViz: Object
        },
        data: () => ({
            showModal: false,
            cmnt: "",
            id: `VIZ-${new Date().getTime()}`,
            res: "",
            levelOnePeriodData: [],
            annotations: [],
            filterPeriodLevel1: '',
            filterPeriodLevel2: 'quarterly',
            //filterPeriodLevel2: 'weekly',
            //filterPeriodLevel2: 'monthly',
            searching: false,
            annotationTitle: '',
            reportTitle: '',
            dataSqlId: '',
            viztypeClassName: '',
            homeData:{}
        }),
        computed: {},
        created() {
            this.loadSummary()
           // console.log("Passed viz prop",this.dcViz);
            bus.$on('banner-changed', (f) => {
                console.log('received event', f)

                this.loadSummary();

            })
        },
        methods: {
            resetChartFunc(){
                dc.filterAll();
                dc.renderAll();
            },
            periodLOne: function () {
                this.filterPeriodLevel2 = 'quarterly'
                //this.filterPeriodLevel2 = 'weekly'
                //this.filterPeriodLevel2 = 'monthly'
               // this.dcSummaryCharts()
                //  this.updateReportData()
            },
            periodLTwo: function () {
                //this.dcSummaryCharts()
            },
            commentBox: function () {
let what = this.dcViz
        console.log(
            `ENTERED into the commentBox function(${what.menuName}, ${what.screenName})`
        );
        this.cmt = "";
        this.pg = what.screenTitleDpName;
        this.section = what.vizletTitleDpName;
        this.annotationHeader = "User Annotations";
        this.annotationTitle =
            this.annotationHeader + "->" + this.pg + "->" + this.section;
        this.$refs["comment-box"].show();

            },
            postAnnotation: function () {
                const url = '/api/annotation';
                const data = {
                    userId: 1,
                    userName: "Admin",
                    page: this.pg,
                    section: this.section,
                    comment: this.cmnt
                };
                axios.post(url, data)
                    .then(() => {
                        //DO nothing
                        console.log('New comment:', data.comment)
                        this.$store.dispatch('loadAnnotations')
                    }, e => {
                        console.error('error in updating annotations', e)
                    })
            },

            resetChart: function(){
            let divId = this.$refs.r1c1;
            console.log("divId",divId.id);
            divId.filterAll();
            dc.redrawAll();
            },

            loadSummary: function () {
                console.log('dc_viz-0','loading state');this.$store.dispatch("loadState").then(() => {
                console.log("Passed viz prop",this.dcViz);
                let allVizType = this.$store.state.vizType;
                let v = this.dcViz;

                let margin = {
                  top: v.pmTop,
                  right: v.pmRight,
                  bottom: v.pmBottom,
                  left: v.pmLeft,
                };

                let vizId = v.vizletId;
                let filter = allVizType.filter((t) => t.viztypeId === vizId)[0];
                let vizname = filter.viztypeClassName
                console.log("vizName in vue", vizname)
                let vizFunction = filter.viztypeFunctionName;

                let divId = this.$refs.r1c1;

                /*let l1period = this.filterPeriodLevel1
                let l2period = this.filterPeriodLevel2
                let alldata = this.dcViz.data
                console.log("All Data passed from parent",alldata);
                let data = l1period !== "" ? alldata.filter(a => a.d4l1_yyyy === l1period) : alldata;
console.log("All data",data)
                if (l2period === "quarterly") {
                    data.forEach(function (a) {
                        a.qt = a.d4l1_yyyy + '-Q' + a.d4l1_qq;
                    });
                } else if (l2period === "monthly") {
                    data.forEach(function (a) {
                        a.qt = a.d4l1_yyyy + '-' + a.d4l1_mm;
                    });
                } else if (l2period === "weekly") {
                    data.forEach(function (a) {
                        a.qt = a.d4l1_yyyy + '-' + a.d4l1_ww;
                    });
                }

                //let alt = crossfilter(data);
               // console.log("Cross filter",alt);
*/
                this.r2c1 = new DcChartInfo(1, this.dcViz, this.dcViz['visibleFlag'], this.dcViz,margin)


                // this.$commonFn.auditLog(homeData[0].menuSyspk,submenuParam,homeData[0].menuName,homeData[0].screenTitle, "GET", "Success")
                setTimeout(async () => {
                  await this.$commonFn.renderDcChart(
                                  vizname,
                                  this.r2c1,
                                  divId,
                                  vizFunction
                              );
                             // dc.renderAll();
                }, 1000)



})
            }
        }
    };
</script>
<style scoped>

</style>